<script>
  export default {
    emits: ['backToAdmin'],
    data() {
      return {
        naslov: '',
        pot: '',
        opis: '',
        ikona: '',
      }
    },
    methods: {
      Add() {
        var podatki = new URLSearchParams();
        podatki.append('naziv', this.naslov);
        podatki.append('pot', this.pot);
        podatki.append('opis', this.opis);
        podatki.append('ikona', this.ikona);
        axios.post('api/nastavitve/meni/vnos/', podatki, {withCredentials: true}).then((response) => {
          alert('Vnos menija uspešen');
        }).catch((error) => {
          alert('Napaka pri vnosu menija:' + error.response.data.napaka);
        });
      },
    }
  }
</script>
<template>
  <button class="p-2 btn-back" @click.prevent="$emit('backToAdmin')"><i class="fas fa-arrow-left fa-2x"></i></button>
  <h5 class="d-flex justify-content-center text-white">Vnos menija</h5>
  <div class="container p-2">
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: naslov.length > 0 }" class="label" for="naslov">Naslov menija</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="naslov" v-model="naslov" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: opis.length > 0 }" class="label" for="opis">Opis menija</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="opis" v-model="opis" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: pot.length > 0 }" class="label" for="pot">Pot</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="pot" v-model="pot" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: ikona.length > 0 }" class="label" for="ikona">ikona, npr: fas fa-angle-up</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="ikona" v-model="ikona" required />
      </div>
    </div>
    <div class="container p-2">
      <button @click.prevent="Add()" class="btn btn-primary rounded-pill btn-add col-12">Dodaj meni</button>
    </div>
  </div>
</template>